import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Store } from '../../state/store.interfaces';
import Icon from '../../common/components/Icon/Icon';
import { LrvTooltip } from '../../common/components/LrvTooltip/LrvTooltip';

import styles from './AnalysisQuantityDetail.module.scss';

interface Props {
  theme?: 'dark' | 'light';
}

export const AnalysisQuantityDetail = (props: Props) => {
  const { theme } = props;
  const [t] = useTranslation();

  const analysisActivityDetail = useSelector((state: Store) => state.activityDashboard.analysisActivityDetail);

  if (analysisActivityDetail.detailAnalysisUsage.totalCount === 0) {
    return null;
  }
  
  return (
    <LrvTooltip
      title={() => (
        <div className={styles.info}>
          <div>{t('clientDashboard.analysisQuantityDetail.archivedCount')}: <strong>{analysisActivityDetail.detailAnalysisUsage.archivedCount + analysisActivityDetail.detailAnalysisUsage.hiddenCount}</strong></div>
          <div>{t('clientDashboard.analysisQuantityDetail.trayCount')}: <strong>{analysisActivityDetail.detailAnalysisUsage.trayCount}</strong></div>
          <div>{t('clientDashboard.analysisQuantityDetail.removedCount')}: <strong>{analysisActivityDetail.detailAnalysisUsage.removedCount}</strong></div>
          <div>{t('clientDashboard.analysisQuantityDetail.totalCount')}: <strong>{analysisActivityDetail.detailAnalysisUsage.totalCount}</strong></div>
        </div>
      )}
    >
      <div>
        <Icon
          name='information'
          type='fill'
          className={styles.icon}
          theme={theme}
        />
      </div>
    </LrvTooltip>
  );
};

